'use client';

import { useDetailContent } from '@eliadmin/core/src/components/dlz/product-detail/details/product-detail-content';
import { ProductParameters } from '@eliadmin/core/src/components/dlz/product-detail/details/product-parameters';
import { ProductTextFields } from '@eliadmin/core/src/components/dlz/product-detail/details/product-text-fields';
import { HtmlRenderer } from '@eliadmin/core/src/components/ui/html-renderer';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';

/**
 * Figma „Section · Details“ (60137:5643): the description column (title, the admin HTML, the text
 * fields as cards) 652 px next to the parameters 636 px, stacked below `lg`. A missing part leaves
 * the other in its column.
 */
export function ProductDetails() {
  const { t } = useTranslations();
  const { description, parameters, textFields } = useDetailContent();
  const hasMain = !!description || textFields.length > 0;

  return (
    <div className="grid gap-6 lg:grid-cols-[minmax(0,652fr)_minmax(0,636fr)] lg:gap-10">
      {hasMain ? (
        <div className="flex min-w-0 flex-col gap-4">
          {description ? (
            <>
              <h2 className="dlz-h3 text-[#0F1012]">{t('text231')}</h2>
              <HtmlRenderer
                html={description}
                className="dlz-rich dlz-body-m text-[#4F545C] [&>:first-child]:mt-0 [&>:last-child]:mb-0"
              />
            </>
          ) : null}
          <ProductTextFields fields={textFields} titleLevel={description ? 'h3' : 'h2'} />
        </div>
      ) : null}
      {parameters.length ? <ProductParameters parameters={parameters} /> : null}
    </div>
  );
}
